export default __webpack_public_path__ + "static/media/i360-logo-192.f081160b.png";